export default __webpack_public_path__ + "static/media/bg_gelbs1.5e59842e.png";